<template lang='pug'>
  .overlay(v-if='renderTier(model)')
    .filter-value-list.filter-categories
      .card.card-light.filter-card.form-check(v-if='showSelectAll')
        router-link.filter-option.form-check-label(:to='filterCategoryLink(model.category)' @click.native='setShowViewResults(true)')
          span(:class='`filter-span-category-${underscore(model.category.attributes.label)}`' v-text='`${$t("products.filters.selectAll")} ${model.category.attributes.label}`')
          span.filter-svg.form-check-input.radio(:class='{ "selected": isCategoryActive(model.category) }')

      .card.card-light.filter-card.form-check(v-for='secondLevelCategory in model.children' v-if='availableChildCategoriesFor(secondLevelCategory.category).length === 0')
        router-link.filter-option.form-check-label(:class='{ "active": isCategoryActive(secondLevelCategory.category) || (isCategoryActive(model.category) && showSelectAll) }' :to='filterCategoryLink(secondLevelCategory.category)' @click.native='setShowViewResults(true)')
          span(:class='`filter-span-category-${underscore(secondLevelCategory.category.attributes.label)}`' v-text='secondLevelCategory.category.attributes.label')
          span.filter-svg.form-check-input.radio(:class='{ "selected": isCategoryActive(secondLevelCategory.category) || (isCategoryActive(model.category) && showSelectAll) }')

      .card.card-light.filter-card(v-for='secondLevelCategory in model.children' v-if='availableChildCategoriesFor(secondLevelCategory.category).length > 0' :key='secondLevelCategory.category.id')
        a.h4.filter-option(@click.prevent.self='addCategoryTrail(secondLevelCategory.category)')
          span(v-text='secondLevelCategory.category.attributes.label')
          span.filter-page-selection(v-if='isChildCategoryActive(secondLevelCategory.category)' v-text='activeCategory.attributes.label')
          .svg-icon.chevron-right.slide-arrow

        transition(name='slide')
          mobile-filter-overlay(v-once :model='secondLevelCategory' v-if='renderTier(secondLevelCategory)')
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { underscore } from '@/modules/services/utilities'

export default {
  name: 'MobileFilterOverlay', // register recursive componet

  props: {
    model: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapState({
      entitySlug: state => state.product.entitySlug,
      entityType: state => state.product.entityType,
      filterCategorySlug: state => state.category.filterCategorySlug,
      filterCategoryTrail: state => state.category.filterCategoryTrail,
      showMobileFilter: state => state.layout.showMobileFilter
    }),

    ...mapGetters([
      'activeCategory',
      'availableChildCategoriesFor',
      'parentIdsForCategory',
      'entityPath'
    ]),

    showSelectAll () {
      return this.model.category && this.model.children.length > 1 && !this.model.isRoot
    }
  },

  created () {
    if (this.model.children.length === 0 && this.model.category) {
      this.model.children.push(
        ...this.availableChildCategoriesFor(this.model.category).map(category => {
          return {
            category,
            tier: this.model.tier + 1,
            children: [],
            isRoot: false
          }
        })
      )
    }
  },

  methods: {
    underscore,
    ...mapMutations(['setShowViewResults']),

    isCategoryActive (category) {
      if (!category) {
        return false
      }
      return category.attributes['slug-url'] === this.entitySlug || category.attributes['slug-url'] === this.filterCategorySlug // speed up display of selected filter
    },

    isChildCategoryActive (category) {
      return this.activeCategory.id && this.parentIdsForCategory(this.activeCategory).split('/').indexOf(category.id) !== -1
    },

    renderTier (model) {
      if (model.tier === -1 || (this.entityType === 'categories' && model.tier < 1)) {
        return true
      }
      return this.filterCategoryTrail[model.tier] && this.filterCategoryTrail[model.tier].id === model.category.id
    },

    addCategoryTrail (category) {
      this.$store.commit('setFilterCategoryTrail', { push: category })
    },

    filterCategoryLink (category) {
      const query = {
        brands: this.$route.query.brands,
        'min-price': this.$route.query['min-price'],
        'max-price': this.$route.query['max-price'],
        other: this.$route.query.other
      }
      return this.entityPath(category.attributes['slug-url'], query)
    }
  }
}
</script>

<style lang='scss' scoped>
  .filter-categories {
    top: 0;
  }
</style>
